// Shared API client to centralize fetch and loading state
// import toast from "react-hot-toast";
import { modalOpenMedical, setLoading } from "../Redux/loadingReducer";
import { getValidAccessToken } from "../Services/oauthService";

export async function apiFetch(dispatch, url, options = {}) {
  try {
    dispatch(setLoading(true));

    const token = await getValidAccessToken();

    // Detect FormData
    const isFormData = options.body instanceof FormData;

    const mergedOptions = {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        ...(options.headers || {}),
      },
    };

    const response = await fetch(url, mergedOptions);
    const data = await response.json().catch(() => null);

    const extractErrors = (payload) => {
      if (!payload) return [];

      if (payload?.errors?.data && typeof payload.errors.data === "object") {
        const fieldErrors = Object.values(payload.errors.data)
          .map((item) => item?.message)
          .filter(Boolean);

        if (fieldErrors.length > 0) {
          return fieldErrors;
        }
      }

      if (Array.isArray(payload?.errors?.message)) {
        return payload.errors.message;
      }

      if (typeof payload?.errors?.message === "string" && payload.errors.message.trim()) {
        return [payload.errors.message];
      }

      if (payload?.data && typeof payload.data === "object") {
        return Object.values(payload.data)
          .map((item) => item?.message)
          .filter(Boolean);
      }

      if (typeof payload?.error === "string" && payload.error.trim()) {
        return [payload.error];
      }

      if (payload?.error?.message) {
        return [payload.error.message];
      }

      return [];
    };

    const getErrorMessage = (payload, fallback) => {
      if (typeof payload?.errors?.message === "string" && payload.errors.message.trim()) {
        return payload.errors.message;
      }

      return payload?.message || fallback;
    };

    if (!response.ok) {
      const errs = extractErrors(data);
      const msg = getErrorMessage(data, "Request failed");

      dispatch(
        modalOpenMedical({
          open: true,
          message: msg,
          errors: errs,
        })
      );

      return {
        success: false,
        message: msg,
        errors: errs,
        status: response.status,
      };
    }
    if (data && data.success === false) {
      const msg = data.message || "Validation Failed";

      let errs = [];

      if (data?.data && typeof data.data === "object") {
        errs = Object.values(data.data).map((item) => item.message);
      }

      dispatch(
        modalOpenMedical({
          open: true,
          message: msg,
          errors: errs,
        })
      );

      return data;
    }

    return data;
  } catch (err) {
    dispatch(
      modalOpenMedical({
        open: true,
        message: err.message || "Something went wrong, please try again",
      }),
    );

    return { success: false, error: err.message };
  } finally {
    dispatch(setLoading(false));
  }
}
